import React, { useContext, useEffect, useState } from "react";

//Components
import PageTitle from "./../layouts/PageTitle";
import AuthContext from "../contexts/auth";
import showPopup from "../components/PopUp";
import api from "../services/config.url";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { Modal } from "antd";
import { FormattedPrice } from "../components/FormatValues";
import ModalPdf from "../components/modal/modalPdf";
import GlobalContext from "../contexts/global";
import { FaDownload, FaEye } from "react-icons/fa";
import { downloadProductPdf } from "../services/downloadPdf";

function Headlines() {
  const [currentPage, setCurrentPage] = useState(1);
  const { user, setCart, cart, setSizeCart, setLoading } =
    useContext(AuthContext);
  const global = useContext(GlobalContext);

  const [response, setResponse] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [pdf, setPdf] = useState("");
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [query, setQuery] = useState({
    current: currentPage,
    pageSize: 50,
  });

  const subtile = global.global?.headerOptions?.find(option => option.type === 'HEALTH');
  const isPremium = !!(
    user?.subscriptionExpiresAt && new Date(user.subscriptionExpiresAt) > new Date()
  );


  useEffect(() => {
    const formattedQuery = new URLSearchParams(query).toString();
    setLoading(true);
    api
      .get(`/customers/products/ebooks?${formattedQuery}`)
      .then((response) => {
        setResponse(response.data);
      })
      .catch((error) => {
        const BackendError = error?.response?.data?.message;
        const genericError = "Não foi possível listar os E-books";
        showPopup(BackendError || genericError, "error");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [currentPage]);

  const handlePdf = (pdf) => {
    setPdf(pdf);
    setIsOpen(true);
  };

  const handleVideoModal = (url) => {
    setVideoUrl(url);
    setIsVideoModalOpen(true);
  };

  const handleCloseVideoModal = () => {
    setIsVideoModalOpen(false);
    setVideoUrl("");
  };

  const addCart = async (data) => {
    if (!user) {
      showPopup(
        "Acesse sua conta para adicionar produtos ao carrinho",
        "alert"
      );
      return navegate.push("/acesso");
    }

    const cartId = cart._id;
    setLoading(true);
    try {
      const response = await api.post(`/customers/cart/${cartId}/item`, {
        product: data._id,
        amountUnit: data?.amount,
        sku: data.sku,
        name: data.name,
        materia: data.materia,
        description: data.description,
      });
      setSizeCart(response.data.items.length);
      setCart(response.data);
      showPopup("Produto adicionado ao carrinho", "success");
    } catch (error) {
      if (error?.response?.data?.message === "Unauthorized") {
        showPopup("Faça login novamente", "error");
        return navegate.push("/acesso");
      }
      showPopup(error.response.data.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
    setQuery({
      ...query,
      current: page,
    });
  };

    const handleDownloadCloud = async (obj) => {
    const sku = obj.sku ?? obj.product?.sku;
    try {
      setLoading(true);
      const response = await api.post(
        `/customers/products/cloud-pdf-sample`,
        {
          sku,
        },
        { "Content-Type": "application/pdf" }
      );

      const pdfBase64 = response.data.downloadUrl;
      setPdf(pdfBase64);
      setIsOpen(true);
      // setIsOpen({ active: true, pdf: pdfBase64 });
    } catch (error) {
      const BackendError = error?.response?.data?.message;
      const genericError = "Erro ao baixar os arquivos";
      showPopup(BackendError || genericError, "error");
    } finally {
      setLoading(false);
    }
  };

  const HeadlineList = () => {
    if (!response.records || response.records.length === 0) {
      return (
        <div className="emptyCart">
          <div>vazio</div>
        </div>
      );
    }

    const styleCard = {
      border: "1px solid #e8e8e8ff",
      borderRadius: "5px",
      padding: "10px",
      marginBottom: "40px",
      backgroundColor: "#f9f9f9",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    }


    return (
      <>
        {response?.records.map((product, index) => (
          <React.Fragment key={index}>
              <div className="container-top-headline" style={styleCard}>
                <div>
                    <div className="img-product-headline">
                      <img
                        src={product?.photos[0]?.photo?.url?? ""}
                        alt={"Imagem"}
                        style={{
                          width: '220px',
                          height: '275px',
                          objectFit: "contain",
                        }}
                      />
                    </div>
                </div>
                <div className="right-content-manchete-product">
                  <div>
                    
                <h5>{product.name}</h5>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: product.description,
                    }}
                    ></div>
                    </div>

                  <div className="manchete-product-actions" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                      {!isPremium && product.amount > 1 &&(
                        <h5 className="amount m-t10">
                          <FormattedPrice price={product?.amount} />
                        </h5>
                        )}
                    <div style={{ width: "100%", textAlign: "center" }}>
                      {isPremium && product.amount !== 1 ? (
                        <button
                          type="button"
                          className="premium-card-cta premium-card-cta-download"
                          onClick={() => downloadProductPdf(product, user, setLoading)}
                        >
                          <FaDownload className="premium-card-cta-icon premium-card-cta-icon-white" />
                          Download
                        </button>
                      ) : (
                        <>
                        {product.amount === 0 &&(
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "10px 24px",
                              height: "36px",
                              borderRadius: "8px",
                              position: "relative",
                              overflow: "hidden"
                            }}
                          >
                            <span style={{
                              fontSize: "15px",
                              fontWeight: "600",
                              color: "#00983dff",
                              letterSpacing: "0.5px",
                              textTransform: "uppercase",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px"
                            }}>
                              Gratuito
                            </span>
                          </div>
                        )}
                      {product.amount != 1 &&(
                      <div
                        className="btn btn-primary btnhover btnhover2  "
                        style={{ height: "36px", width: "80", marginLeft: '10px' }}
                        onClick={() => addCart(product)}
                      >
                        <i className="flaticon-shopping-cart-1"></i>
                        <span className="m-1 desktop-message">Adicionar no carrinho</span>
                      </div>
                      )}

                       {product.amount === 1 &&(
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "10px 24px",
                            height: "36px",
                            border: "2px solid #bbb",
                            borderRadius: "8px",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                            position: "relative",
                            overflow: "hidden"
                          }}
                        >
                          <span style={{
                            fontSize: "15px",
                            fontWeight: "600",
                            color: "#666",
                            letterSpacing: "0.5px",
                            textTransform: "uppercase",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px"
                          }}>
                            Em breve
                          </span>
                        </div>
                      )}
                        </>
                      )}
                    </div>
                  </div>
                    {product?.hasSample && product?.amount > 1 && (
                      <button
                        type="button"
                        className="premium-card-cta"
                        onClick={() => handleDownloadCloud(product)}
                      >
                        <FaEye className="premium-card-cta-icon premium-card-cta-icon-white" />
                        Ver amostra
                      </button>
                    )}

                    {product.href && (
                        <div
                          onClick={() => handleVideoModal(product.href)}
                          style={{  }}
                        >
                          <p className="m-0 " style={{  padding: '4px 10px 4px 10px', backgroundColor: "#ba6767ff", color: '#fff', borderRadius: '7px', cursor: 'pointer'}}> Ver vídeo </p>
                        </div>
                      )}
                    {/* <h5 className="amount m-t10">
                      <FormattedPrice price={product?.amount} />
                    </h5>
                    <div style={{ width: "100%", textAlign: "center" }}>
                      <div
                        className="btn btn-primary btnhover btnhover2 "
                        style={{ height: "36px", width: "80" }}
                        onClick={() => addCart(product)}
                      >
                        <i className="flaticon-shopping-cart-1"></i>
                        <span className="m-1 desktop-message">Adicionar no carrinho</span>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
                 
  
          </React.Fragment>
        ))}
      </>
    );
  };

  return (
    <div className="header-padding-main">
      <div className="page-content bg-white">
        <PageTitle parentPage="CJ" childPage={subtile?.name ?? ''} />

        <ModalPdf
          pdf={pdf}
          isModalOpen={isOpen}
          isModalClose={() => setIsOpen(false)}
        />

        {/* Modal para exibir vídeo */}
        <Modal
          title="Vídeo do E-book"
          open={isVideoModalOpen}
          onCancel={handleCloseVideoModal}
          footer={null}
          width={800}
          centered
        >
          {videoUrl && (
            <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
              <iframe
                src={videoUrl}
                title="Vídeo do E-book"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }}
              />
            </div>
          )}
        </Modal>

        {/* <section className="content-inner-2 m-b30 testimonial-wrapper">
          <CarouselHeadline items={productsHeadline} />
        </section> */}

        <section className="container m-t100 box-about-us">
          <div className="col-lg-12 m-b100">
            <HeadlineList />
          </div>
          <div className="pagination-component">
            <Stack spacing={2}>
              <Pagination
                count={response.pages}
                page={currentPage}
                onChange={(event, page) => handlePagination(page)}
              />
            </Stack>
          </div>
        </section>
      </div>
    </div>
  );
}
export default Headlines;
